import React from 'react';
import './check-icon.scss';
import Checked from '../../../shared/assets/images/icon-checked.svg'

const CheckIcon = ({checked}) => {
    return(
        <div className={`f-check-icon ${checked ? 'f-check-icon-checked' : '' }`}  >
            {checked && <img  className='f-check-icon-check' alt='check-icon' src={Checked} /> }
        </div>
    )
}

export default CheckIcon;